export const ERROR_MSG_METHOD_NOT_IMPLEMENTED = 'Method not implemented.';
export const ERROR_MSG_USE_DOCUMENT_ELEMENT =
  'Use document.documentElement instead.';
export const ERROR_MSG_APPEND_DESTROYED_ELEMENT =
  'Cannot append a destroyed element.';
